<input
  type="file"
  class="form-control"
  autocomplete="new-data"
  [ngClass]="class" />
